import {
  urlLogin,
  urlCambiarContrasenia,
  urlRecuperarContrasenia,
  urlVerificarToken,
  urlListarCompras,
  urlConsultarUsrOkta,
  urlRedireccionLogin,
  urlExportarExcel,
  urlListarRenovaciones,
  urlListarCarrito,
} from "../../constants/urls";
import { urlLoginPost } from "../../constants/urls";
import { createAction } from "redux-actions";
import moment from "moment";
import { stringABase64 } from "../../utils/Encriptar";
import { apiGet, apiPost2 } from "../../api";
import { httpClient } from "../../api/httpClient";

export const LOGIN_HAS_ERRORED = "LOGIN_HAS_ERRORED";
export const LOGIN_IS_LOADING = "LOGIN_IS_LOADING";
export const CAMBIAR_CONTRASENIA_HAS_ERRORED =
  "CAMBIAR_CONTRASENIA_HAS_ERRORED";
export const CAMBIAR_CONTRASENIA_IS_LOADING = "CAMBIAR_CONTRASENIA_IS_LOADING";

export const SOLICITAR_CONTRASENIA_HAS_ERRORED =
  "SOLICITAR_CONTRASENIA_HAS_ERRORED";
export const SOLICITAR_CONTRASENIA_IS_LOADING =
  "SOLICITAR_CONTRASENIA_IS_LOADING";

export const VERIFICAR_TOKEN_HAS_ERRORED = "VERIFICAR_TOKEN_HAS_ERRORED";
export const VERIFICAR_TOKEN_IS_LOADING = "VERIFICAR_TOKEN_IS_LOADING";
export const RECUPERAR_CONTRASENIA_OK = "RECUPERAR_CONTRASENIA_OK";

export const USER_IS_LOGGED_IN = "USER_IS_LOGGED_IN";
export const CAMBIAR_CONTRASENIA_OK = "CAMBIAR_CONTRASENIA_OK";
export const SET_MSG_ERROR_CAMBIO_CONTRASENA =
  "SET_MSG_ERROR_CAMBIO_CONTRASENA";
export const SET_DATA_USUARIO = "SET_DATA_USUARIO";

export const ENVIAR_CORREO = "ENVIAR_CORREO";
export const LIMPIAR_LOGIN = "LIMPIAR_LOGIN";
export const LIMPIAR_CAMBIAR_CONTRASENIA = "LIMPIAR_CAMBIAR_CONTRASENIA";
export const LIMPIAR_SOLICITAR_CONTRASENIA = "LIMPIAR_SOLICITAR_CONTRASENIA";
export const LIMPIAR_TOKEN = "LIMPIAR_TOKEN";
export const SET_COUNT_CARRITO = "SET_COUNT_CARRITO";
export const SET_DATA_LEEDS = "SET_DATA_LEEDS";

export const LISTA_COMPRAS_HAS_ERRORED = "LISTA_COMPRAS_HAS_ERRORED";
export const SET_DATA_LISTA_COMPRAS = "SET_DATA_LISTA_COMPRAS";
export const SET_DATA_LISTA_RAMOS = "SET_DATA_LISTA_RAMOS";
export const LISTA_COMPRAS_LOADING = "LISTA_COMPRAS_LOADING";
export const LIMPIAR_DATOS_LISTA_COMPRAS = "LIMPIAR_DATOS_LISTA_COMPRAS";

const loginError = createAction(LOGIN_HAS_ERRORED);
const loginIsLoading = createAction(LOGIN_IS_LOADING);
const cambiarContraseniaError = createAction(CAMBIAR_CONTRASENIA_HAS_ERRORED);
const cambiarContraseniaIsLoading = createAction(
  CAMBIAR_CONTRASENIA_IS_LOADING
);
const verificarTokenError = createAction(VERIFICAR_TOKEN_HAS_ERRORED);
const verificarTokenIsLoading = createAction(VERIFICAR_TOKEN_IS_LOADING);
const solicitarContraseniaError = createAction(
  SOLICITAR_CONTRASENIA_HAS_ERRORED
);
const solicitarContraseniaIsLoading = createAction(
  SOLICITAR_CONTRASENIA_IS_LOADING
);

export const limpiarCambioContrasenia = createAction(
  LIMPIAR_CAMBIAR_CONTRASENIA
);

export const limpiarVerificarToken = createAction(LIMPIAR_TOKEN);

export const limpiarSolicitarContrasenia = createAction(
  LIMPIAR_SOLICITAR_CONTRASENIA
);

export const limpiarLogin = createAction(LIMPIAR_LOGIN);
export const setContraseniaOK = createAction(CAMBIAR_CONTRASENIA_OK);
export const setMsgCambiarContrasena = createAction(
  SET_MSG_ERROR_CAMBIO_CONTRASENA
);
export const recuperarContraseniaOK = createAction(RECUPERAR_CONTRASENIA_OK);
export const enviarCorreo = createAction(ENVIAR_CORREO);

export const dataUsuario = createAction(SET_DATA_USUARIO);
export const setDataLeeds = createAction(SET_DATA_LEEDS);
export const listaComprasHasErrored = createAction(LISTA_COMPRAS_HAS_ERRORED);
export const listaComprasIsLoading = createAction(LISTA_COMPRAS_LOADING);
export const setListaCompras = createAction(SET_DATA_LISTA_COMPRAS);
export const setListaRamos = createAction(SET_DATA_LISTA_RAMOS);
export const limpiarListaCompras = createAction(LIMPIAR_DATOS_LISTA_COMPRAS);

//renovaciones
export const LISTA_RENOVACIONES_HAS_ERRORED = "LISTA_RENOVACIONES_HAS_ERRORED";
export const SET_DATA_LISTA_RENOVACIONES = "SET_DATA_LISTA_RENOVACIONES";
export const SET_DATA_LISTA_ESTADOS = "SET_DATA_LISTA_ESTADOS";
export const LISTA_RENOVACIONES_LOADING = "LISTA_RENOVACIONES_LOADING";
export const LIMPIAR_DATOS_LISTA_RENOVACIONES = "LIMPIAR_DATOS_LISTA_RENOVACIONES";
export const SET_RENOVACION_SELECCIONADA = "SET_RENOVACION_SELECCIONADA";

export const limpiarListaRenovaciones = createAction(LIMPIAR_DATOS_LISTA_RENOVACIONES);
export const setListaRenovaciones = createAction(SET_DATA_LISTA_RENOVACIONES);
export const setListaEstados = createAction(SET_DATA_LISTA_ESTADOS);
export const listaRenovacionesHasErrored = createAction(LISTA_RENOVACIONES_HAS_ERRORED);
export const listaRenovacionesIsLoading = createAction(LISTA_RENOVACIONES_LOADING);
export const setRenovacionSeleccionada = createAction(SET_RENOVACION_SELECCIONADA);

export function userIsLoggedIn(bool) {
  return {
    type: USER_IS_LOGGED_IN,
    userIsLoggedIn: bool,
  };
}
export function countCarrito(val) {
  return {
    type: SET_COUNT_CARRITO,
    countCarrito: val,
  };
}

// Actions para  OKTA
export const setAutenticarOkta = createAction('SET_AUTENTICAR_OKTA');
export const setOktaHasError = createAction('SET_OKTA_HAS_ERROR');
export const setOktaIsLoading = createAction('SET_OKTA_IS_LOADING');



// Objeto data usuario
const dataUsuario1 = {
  correo: "",
  cedula: "",
  nombres: "",
  apellidos: "",
  sucursal: "",
  sucursalCodCore: "",
  errorDescripcion: "",
  userIsLoggedIn: false,
  cliCodigoCore: "",
  disclaimerVer: false,
  disclaimerFecha: "",
  disclaimerUrl: "",
};

export const FetchExportarEccel = (param, ambiente, id = null, rangoFecha, filtros = {
  "color": "",
  "marca": ""
}, history) => async (dispatch) => {
  var url = `${urlExportarExcel}${param}&ambiente=${ambiente}&ramo=VEHÍCULOS`;
  //console.log("AAAAAAAAAAAAAAA", url)
  dispatch(listaRenovacionesIsLoading(true));
  await httpClient.post(url,
    {
      rangoFecha: rangoFecha ? rangoFecha : "10-10-2000 | 10-10-2026",
      "filtrosAtributos": filtros ? {
        "reDatosContratante.reIdentificacion": filtros.identificacionContratante,
        "reDatosPagador.reNombre1": filtros.nombreContratante,
        "reDatosProducto.reDatosVehiculo.rePlaca": filtros.placa,
        "reDatosProducto.reDatosVehiculo.reMarca": filtros.marca,
        "reDatosProducto.reDatosVehiculo.reModelo": filtros.modelo,
        "reDatosProducto.reProducto": filtros.polDescripcionSeguro,
        "reNumPoliza": filtros.numeroPolizaEmision,
        "reCorePoliza": filtros.numeroCompra,
        "reDatosBroker.rebrokersucursal": filtros.sucursal,
        "reEstadoRenovacion": filtros.reEstadoRenovacion
      } : {}
    }


  )


    .then((data) => {
      console.log('renovacionesVer', data)

      if (data.transaccion) {

        window.open(data.url, '_blank');



      }

      dispatch(listaRenovacionesIsLoading(false));
    })
    .catch((response) => {
      dispatch(listaRenovacionesHasErrored());
      dispatch(setListaRenovaciones([]));
      dispatch(setListaEstados([]));
    });
};



export const formatearNumero = (s) => {
  try {
    // Reemplaza la coma por un punto para convertir correctamente a número
    let numero = parseFloat(s);

    if (isNaN(numero)) {
      throw new Error("Valor no numérico");
    }

    // Formatear con separador de miles y dos decimales
    return numero.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } catch (error) {
    // Si hay un error, devuelve "0.00" en el formato correcto
    return "0.00";
  }
}


// ------------------ INICIAN Funciones que utilizan Actions ------------------

export const loginFetch = (body) => async (dispatch) => {
  dispatch(loginIsLoading());
  await fetch(urlLoginPost,{
    method: 'POST',
    body: JSON.stringify({
        ...body
    })
  })
    .then((response) => response.json())
    .then((data) => {
      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        let nombres1 = data.cliNombre1 + " " + data.cliNombre2;
        let apellidos1 = data.cliApellido1 + " " + data.cliApellido2;
        let disFechaAux = "";
        if (
          data.disclaimerFecha !== null &&
          data.disclaimerFecha !== "" &&
          data.disclaimerFecha !== undefined
        ) {
          disFechaAux = data.disclaimerFecha;
        }
        if (!data.cliNombre2) nombres1 = data.cliNombre1;

        if (!data.cliApellido2) apellidos1 = data.cliApellido1;

        const dataUsuario2 = {
          ...dataUsuario1,
          correo: data.cliEmail,
          cedula: data.cliIdentificacion,
          nombres: nombres1,
          apellidos: apellidos1,
          sucursal: data.cliSucursal,
          sucursalCodCore: data.sucCodigoCore,
          errorDescripcion: data.errorDescripcion,
          userIsLoggedIn: true,
          cliCodigoCore: data.cliCodigoCore,
          disclaimerVer: data.disclaimerVer,
          disclaimerFecha: disFechaAux,
          disclaimerUrl: data.disclaimerUrl,
          usu_tipo_usuario: data.cliTipo,
          brokerRUC: data.brokerRUC ? data.brokerRUC : "",
          brokerNombre: data.brokerNombre ? data.brokerNombre : "",
          brokerCodigo: data.brokerCodigo ? data.brokerCodigo : "",
          fechaUltimoAcceso: data.fechaUltimoAcceso
            ? data.fechaUltimoAcceso
            : undefined,
            fromMobile:false,
          clienteFinal:false
        };
        dispatch(dataUsuario(dataUsuario2));
      } else {
        const dataUsuario1 = {
          ...dataUsuario,
          errorDescripcion: data.errorDescripcion,
        };
        dispatch(dataUsuario(dataUsuario1));
        dispatch(loginError());
      }
    })

    .catch(() => {
      const dataUsuario1 = {
        ...dataUsuario,
        errorDescripcion: "Error general",
      };
      dispatch(dataUsuario(dataUsuario1));
      dispatch(loginError());
    });
};

export const solicitarContraseniaFetch = (body, history) => async (
  dispatch
) => {
  console.log("cambiar", urlRecuperarContrasenia + body);
  dispatch(solicitarContraseniaIsLoading());
  await fetch(urlRecuperarContrasenia + body)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);

      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(enviarCorreo(true));
      } else {
        console.log("entre a else ", transaccion);
        dispatch(solicitarContraseniaError());
      }
    })

    .catch(() => {
      dispatch(solicitarContraseniaError());
    });
};

const fechaActual = moment().add(0, 'days').startOf('day');



function convertirTimestampAFecha(fecha) {
  // Convertir el timestamp de milisegundos a segundos
  const timestampInSeconds = Math.floor(fecha / 1000);

  // Crear un objeto de fecha desde el timestamp
  const fechaObj = new Date(timestampInSeconds * 1000);

  // Establecer la zona horaria en UTC y ajustar la hora a las 23:59:59
  fechaObj.setUTCHours(23, 59, 59, 0);

  // Formatear la fecha a 'Y-m-d H:i:s'
  const año = fechaObj.getUTCFullYear();
  const mes = String(fechaObj.getUTCMonth() + 1).padStart(2, '0'); // Mes empieza en 0
  const día = String(fechaObj.getUTCDate()).padStart(2, '0');
  const horas = String(fechaObj.getUTCHours()).padStart(2, '0');
  const minutos = String(fechaObj.getUTCMinutes()).padStart(2, '0');
  const segundos = String(fechaObj.getUTCSeconds()).padStart(2, '0');

  return `${año}-${mes}-${día} ${horas}:${minutos}:${segundos}`;
}

export const transformarRenovacion= (renovacion,filtros)=>{

  let datos = []

  datos.push(renovacion)

  console.log('transformarDatos',renovacion, filtros)

 return  transformarDatos(datos, filtros)[0]
}


export const validarBotonContinuar = (renovacion) => {



  console.log('obtenerUltimafecha123123',renovacion)


  const { estado, fechaCaducidadCobP } = renovacion

  const fechaCaducidadCobProvisional = moment(convertirTimestampAFecha(fechaCaducidadCobP)).startOf('day');

  const fechaCarta = moment(convertirTimestampAFecha(renovacion.fechaCaducidadNoS)).startOf('day');

  const ultimaFecha =  moment(convertirTimestampAFecha(obtenerUltimafecha(renovacion))).startOf('days')

  console.log('ultimaFecha', ultimaFecha)




  if (estado == "PROVISIONAL_SOLICITADA" && renovacionTieneCarrito(renovacion) && fechaActual.isSameOrBefore(fechaCaducidadCobProvisional)) {
    return true
  }


  if (estado == "NO_SINIESTROS_FIRMADA" && renovacionTieneCarrito(renovacion) && fechaActual.isSameOrBefore(fechaCarta)) {
    return true
  }


  if (estado == "NO_SINIESTROS_SOLICITADA" && renovacionTieneCarrito(renovacion) && fechaActual.isSameOrBefore(ultimaFecha)) {
    return true
  }

  if ((estado == "EN_PROCESO" || renovacion.estado == 'NO_RENOVABLE') && renovacionTieneCarrito(renovacion) && fechaActual.isSameOrBefore(ultimaFecha)) {
    return true
  }else{
    return false
  }


}

export const validarCoberturaProvisional = (renovacion) => {




  if (renovacion == {}) {
    return false
  }
  // Estados no válidos para cobertura provisional
  const estadosNoValidos = [
    'VENCIDAS',
    'PROVISIONAL_SOLICITADA',
    'EN_PROCESO_2',
    'NO_SINIESTROS_SOLICITADA',
    'NO_SINIESTROS_FIRMADA',
    'NO_RENOVABLE',
    'FVC',
    'FVP',
    'ES',
    'RENOVADA',
    'ET'
  ];

  if (estadosNoValidos.includes(renovacion.estado)) {
    return false;
  }


  if (renovacion.aplicarRecompra) {
    return false
  }

  console.log('renovacion', typeof renovacion, renovacion)

  let numeroDias = parseInt(renovacion.filtros[1].reValores[0].reValor, 10);
  const fechaCaducidad = moment(renovacion.mesCaducidad).startOf('day');
  const fechaLimite = fechaCaducidad.clone().subtract(numeroDias, 'days');

  console.log('fechaLimite', numeroDias, fechaCaducidad.format(), fechaLimite.format())


  if (renovacion.estado === 'POR_RENOVAR' || renovacion.estado === 'EN_PROCESO') {
    const estaEnRango = fechaActual.isSameOrBefore(fechaCaducidad) && fechaActual.isSameOrAfter(fechaLimite);

    if (renovacion.estado === 'EN_PROCESO' && renovacion.fechaCaducidadCobP) {
      return false; // Si existe la fecha, se invalida
    }

    return estaEnRango;
  }

  const validacion = fechaActual.isSameOrAfter(fechaLimite);

  console.log('Validación de cobertura provisional:', validacion);

  return validacion;
};



export const renovacionTieneCarrito = (renovacion) => {
  return /^[a-fA-F0-9]{24}$/.test(renovacion.reIdCarrito);
}


export const validarBotonCarta = (renovacion) => {

  if (renovacion.aplicarRecompra) {
    return false
  }
  //  return true
  if (renovacion.estado === 'PROVISIONAL_SOLICITADA') {



    if (renovacion.aplicarRecompra) {
      return false
    }

    const numeroDiasPosteriores = parseInt(renovacion.filtros[2].reValores[0].reValor, 10);

    const fechaCaducidadCobProvisional = moment(convertirTimestampAFecha(renovacion.fechaCaducidadCobP)).startOf('day');


    const fechaLimiteInferiorCarta = fechaCaducidadCobProvisional.clone().add(numeroDiasPosteriores, 'days')

    console.log('fechaCaducidadCobProvisional', fechaCaducidadCobProvisional.format(), fechaLimiteInferiorCarta.format())

    const validacion = fechaActual.isSameOrAfter(fechaCaducidadCobProvisional) && fechaActual.isSameOrBefore(fechaLimiteInferiorCarta)

    console.log('numeroDiasPosteriores', fechaActual.format(), validacion)

    return validacion



  }


  if (renovacion.estado == 'POR_RENOVAR' || renovacion.estado == 'EN_PROCESO') {
    const numeroDias = parseInt(renovacion.filtros[2].reValores[0].reValor)
    const fechaCaducidad = moment(renovacion.mesCaducidad).startOf('day');
    const fechaCaducidadNueva = fechaCaducidad.clone().add(numeroDias, 'days')

    var validacion = fechaActual.isAfter(fechaCaducidad) && fechaActual.isSameOrBefore(fechaCaducidadNueva)

    if (renovacion.estado == "EN_PROCESO" && renovacion.fechaCaducidadNoS) {
      validacion = false
    }
    return validacion;
  }

  // Por defecto, no se permite
  return false;
};

const obtenerUltimafecha = (renovacion) => {

  let fechaCaducidad = renovacion.reDatosProducto.reFechaCaducidad

  if (renovacion.fechaCaducidadCobP) {

    fechaCaducidad = renovacion.fechaCaducidadCobP

  }

  if (renovacion.fechaCaducidadNoS) {

    fechaCaducidad = renovacion.fechaCaducidadNoS
  }

  return fechaCaducidad


}

const obtenerFechaCobertura = (renovacion, filtros) => {


  const numeroDias = parseInt(filtros[1].reValores[1].reValor, 10);

  console.log('errorverrrr', numeroDias)

  try {
    return moment(convertirTimestampAFecha(renovacion.fechaCaducidadCobP)).startOf('days').format('YYYY-MM-DD')
  } catch (error) {
    console.log('errorverrrr', error)
    return ''
  }



}

const obtenerFechaCarta = (renovacion, filtros) => {


  const numeroDias = parseInt(filtros[1].reValores[1].reValor, 10);

  console.log('errorverrrr', numeroDias)

  try {
    return moment(convertirTimestampAFecha(renovacion.fechaCaducidadNoS)).startOf('days').format('YYYY-MM-DD')
  } catch (error) {
    console.log('errorverrrr', error)
    return ''
  }



}

export const validarModuloRenovacion = (tipoUsuario) => {

  // return false

  return tipoUsuario == 'broker-user' || tipoUsuario == 'asesor-user' || tipoUsuario == 'canal-user'

}


export const validarBotonFv = (renovacion) => {

  return renovacion.estado == 'FVP'
}


export const validarBotonRenovar = (renovacion) => {


  // Estados que no permiten renovar
  const estadosNoPermitidos = ['EN_PROCESO', 'VENCIDAS', 'EN_PROCESO_2', 'NO_SINIESTROS_SOLICITADA', 'NO_RENOVABLE', 'FVP', 'FVC', 'ES', 'RENOVADA', 'ET'];
  if (estadosNoPermitidos.includes(renovacion.estado)) {
    return false;
  }

  if (renovacion.aplicarRecompra) {
    return false
  }

  const fechaCaducidad = moment(renovacion.mesCaducidad).startOf('day');
  const fechaCobertura = moment(convertirTimestampAFecha(renovacion.fechaCaducidadCobP)).startOf('day');
  const fechaLimiteCobertura = fechaCobertura.clone()

  // Validación para estado 'NO_SINIESTROS_FIRMADA'
  if (renovacion.estado === 'NO_SINIESTROS_FIRMADA') {

    const fechaCarta = moment(convertirTimestampAFecha(renovacion.fechaCaducidadNoS)).startOf('day');

    console.log('fechaCarta', fechaCarta)


    return fechaActual.isSameOrBefore(fechaCarta) && !renovacionTieneCarrito(renovacion);
  }


  // Validación para estado 'PROVISIONAL_SOLICITADA'
  if (renovacion.estado === 'PROVISIONAL_SOLICITADA') {




    return fechaActual.isSameOrBefore(fechaLimiteCobertura) && !renovacionTieneCarrito(renovacion);
  }

  // Validación general
  return fechaActual.isSameOrBefore(fechaCaducidad);
};


export const validarBotonRecompra = (renovacion) => {
  // Estados que no permiten renovar
  const estadosPermitidos = ['POR_RENOVAR'];
  if (!estadosPermitidos.includes(renovacion.estado)) {
    return false;
  }

  if (!renovacion.aplicarRecompra) {


    return false
  }


  const fechaCaducidad = moment(renovacion.mesCaducidad).startOf('day');

  // Validación para estado 'NO_SINIESTROS_FIRMADA'
  if (renovacion.estado === 'NO_SINIESTROS_FIRMADA') {
    const numeroDias = parseInt(renovacion.filtros[1].reValores[1].reValor, 10);
    const fechaCobertura = moment(convertirTimestampAFecha(renovacion.fechaCaducidadCobP)).startOf('day');
    const fechaLimiteCobertura = fechaCobertura.clone().add(numeroDias, 'days');

    return fechaActual.isSameOrBefore(fechaLimiteCobertura);
  }

  // Validación para estado 'PROVISIONAL_SOLICITADA'
  if (renovacion.estado === 'PROVISIONAL_SOLICITADA') {
    return fechaActual.isSameOrBefore(fechaCaducidad);
  }

  // Validación general
  return fechaActual.isSameOrBefore(fechaCaducidad);
};

export const obtenerSumaAsegurada = (renovacion) => {



  if (renovacion && renovacion.reDatosProducto && renovacion.reDatosProducto.reDatosVehiculo && Array.isArray(renovacion.reDatosProducto.reDatosVehiculo)) {
    let datosVehiculo = renovacion.reDatosProducto.reDatosVehiculo

    let valorSuma = 0

    datosVehiculo.forEach(element => {

      valorSuma += parseFloat(element.reValorAsegurado)

    });
    return formatearNumero(valorSuma)

  } else {
    return 0
  }
}

export const FetchListadoRenovaciones = (param, ambiente, id = null, rangoFecha, filtros = {
  "color": "",
  "marca": ""
}) => async (dispatch) => {
  var url = `${urlListarRenovaciones}${param}&ambiente=${ambiente}&ramo=VEHÍCULOS`;
  //console.log("AAAAAAAAAAAAAAA", url)
  dispatch(listaRenovacionesIsLoading(true));
  await httpClient.post(url,
    {
      rangoFecha: rangoFecha ?rangoFecha : null,
      "filtrosAtributos": filtros ? {
        "reDatosPagador.reIdentificacion": filtros.identificacionContratante,
         "reDatosContratante.reEmail": filtros.emailContratante,
        "reDatosPagador.reNombre1": filtros.nombreContratante,
        "reDatosProducto.reDatosVehiculo.rePlaca": filtros.placa,
        "reDatosProducto.reDatosVehiculo.reMarca": filtros.marca,
        "reDatosProducto.reDatosVehiculo.reModelo": filtros.modelo,
        "reDatosProducto.reProducto": filtros.polDescripcionSeguro,
        "reNumPoliza": filtros.numeroPolizaEmision,
        "reCarritoContador": filtros.reCarritoContador,
        "reDatosBroker.rebrokersucursal": filtros.sucursal,
        "reEstadoRenovacion": filtros.reEstadoRenovacion
      } : {}
    }


  )


    .then((data) => {
      console.log('renovacionesVer', data)

      if (data.arrayrenovaciones) {




        if (data.arrayrenovaciones !== undefined) {

          const datostransformados = transformarDatos(data.arrayrenovaciones, data.arrayFiltrosBack)

          console.log('datostransformados', datostransformados)




          const resultado = datostransformados.reduce((acc, curr) => {
            const index = acc.findIndex(item => item.id === curr.reEstadoRenovacionCod);
            if (index !== -1) {
              acc[index].value += 1;
            } else {
              acc.push({
                name: curr.estadoVer,
                id: curr.estado,
                value: 1
              });
            }
            return acc;
          }, []);

          console.log('resultado', resultado)





          var filtros = [{
            "name": "Todas",
            "id": "todas",
            "value": data.arrayrenovaciones.length
          }


          ]

          console.log('Compras-Ventas 3222', filtros, data.arrayrenovaciones)


          resultado.forEach(element => {
            filtros.push(element)

          });

          const uniqueArray = [...new Map(filtros.map(item => [item.name, item])).values()];

          dispatch(limpiarListaRenovaciones());





          dispatch(setListaRenovaciones(datostransformados));
          dispatch(setListaEstados(uniqueArray));


          if (id) {




            let renovacionSeleccionada = {
              alldata: data.arrayrenovaciones.find(data => data._id == id),
              dataTransformada: datostransformados.find(data => data.id == id)
            }

            dispatch(listaRenovacionesIsLoading(false));

            console.log('venta222', renovacionSeleccionada)
            dispatch(setRenovacionSeleccionada(renovacionSeleccionada))
          }
        } else {
          dispatch(limpiarListaRenovaciones());
        }
      } else {
        dispatch(listaRenovacionesHasErrored());
        dispatch(setListaRenovaciones([]));
        dispatch(setListaEstados([]));
      }
    })
    .catch((response) => {
      dispatch(listaRenovacionesHasErrored());
      dispatch(setListaRenovaciones([]));
      dispatch(setListaEstados([]));
    });
};


function transformarDatos(arrayDatos, filtros) {

  console.log('arrayDatos', arrayDatos)


  return arrayDatos.map((dato, index) => {



    let sumaAsegurada = obtenerSumaAsegurada(dato)
    console.log('verDatosss', sumaAsegurada)
    // Validar si la fecha de caducidad está definida
    const fechaCaducidad = dato && dato.reDatosProducto && dato.reDatosProducto.reFechaCaducidad
      ? new moment(parseInt(dato.reDatosProducto.reFechaCaducidad)).format('YYYY-MM-DD')
      : null;

    const fechaCreacion = dato && dato.reDatosProducto && dato.reDatosProducto.reFechaInicio
      ? new moment(parseInt(dato.reDatosProducto.reFechaInicio)).format('YYYY-MM-DD')
      : null;

    // Si no hay fecha de caducidad, asignamos un valor por defecto
    const mesCaducidad = dato && dato.reDatosProducto && dato.reDatosProducto.reFechaCaducidad
      ? dato.reDatosProducto.reFechaCaducidad
      : '';

    const marca = dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo.reMarca
      ? dato.reDatosProducto.reDatosVehiculo.reMarca
      : ''; // Validar marca del vehículo
    const placa = dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo[0] && dato.reDatosProducto.reDatosVehiculo[0].rePlaca
      ? dato.reDatosProducto.reDatosVehiculo.rePlaca
      : ''; // Validar placa

    const vehiculoAll = dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo
      ? dato.reDatosProducto.reDatosVehiculo
      : []; // Validar placa
    const anio = dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo.reAño
      ? dato.reDatosProducto.reDatosVehiculo.reAño
      : ''; // Validar año
    const modelo = dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo.reModelo
      ? dato.reDatosProducto.reDatosVehiculo.reModelo
      : ''; // Validar modelo

    const vehiculo = `
     <b>Placa:</b> ${placa}
  <b>Marca:</b> ${marca}
  <b>Modelo:</b> ${modelo}
  <b>Año:</b> ${anio}
`;

    let datoModificado = {
      ...dato,
      filtros: filtros,
      id: dato && dato._id ? dato._id : '', // Validar si _id existe
      contador: index + 1,
      reNuevosValores: dato.reNuevosValores,
      fechaCobertura: dato.fechaCaducidadCobP ? obtenerFechaCobertura(dato, filtros) : '',
      fechaCarta: dato.fechaCaducidadNoS ? obtenerFechaCarta(dato, filtros) : '',
      noItems: dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo[0]
        ? dato.reDatosProducto.reDatosVehiculo.length
        : 1,
      fechaCreacion: fechaCreacion,
      nombreContratante: dato && dato.reDatosContratante && dato.reDatosContratante.reNombre1 && dato.reDatosContratante.reNombre1 != '-'
        ? `${dato.reDatosContratante.reNombre1} ${dato.reDatosContratante.reApellido1 ? dato.reDatosContratante.reApellido1 : ''}`
        : dato.reDatosContratante.reRazonSocial ? dato.reDatosContratante.reRazonSocial : dato.reDatosContratante.reNombre, // Validar si los campos existen
      polIdentificacionesAsegurados: dato && dato.reDatosContratante && dato.reDatosContratante.reIdentificacion,
       emailContratante: dato && dato.reDatosContratante && dato.reDatosContratante.reEmail
        ? dato.reDatosContratante.reEmail
        : '', // Validar identificación
      polDescripcionRamo: dato && dato.reDatosProducto && dato.reDatosProducto.reRamo
        ? dato.reDatosProducto.reRamo
        : '', // Validar ramo
      polDescripcionSeguroVer: dato.reDatosProducto.reProducto,
      noPortal: dato.reDatosProducto.productoNoPortal,
      polDescripcionSeguro: dato && dato.aplicarRecompra
        ? 'Kilómetros paquete'
        : dato && dato.reDatosProducto && dato.reDatosProducto.esPractiAuto ? 'PRACTIAUTO'
          : 'AIG AUTO',
      numeroPolizaEmision: dato && dato.reNumPoliza ? dato.reNumPoliza : '', // Validar número de póliza
      numeroCompra: dato && dato.reCarritoContador ? dato.reCarritoContador : '', // Validar corePóliza
      traMetodoPago: 'No especificado', // Ajusta si tienes el dato en otro campo
      total: dato && dato.reDatosProducto && dato.reDatosProducto.rePrimaNeta && dato.reDatosProducto.reScoring
        ? parseFloat(dato.reDatosProducto.rePrimaNeta) + parseFloat(dato.reDatosProducto.reScoring)
        : 0, // Validar prima final

      primaNeta: dato && dato.reDatosProducto && dato.reDatosProducto.rePrimaNeta
        ? parseFloat(dato.reDatosProducto.rePrimaNeta)
        : 0, // Validar prima final
      detalles: "Ver detalles", // Ajusta según sea necesario
      estado: dato && dato.reEstadoRenovacionCod ? dato.reEstadoRenovacionCod : '', // Validar estado
      estadoVer: dato && dato.reEstadoRenovacion ? dato.reEstadoRenovacion : '', // Validar estado
      vehiculo: vehiculo,
      reUrlFormulario: dato.reUrlFormulario,
      marca: dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo[0] && dato.reDatosProducto.reDatosVehiculo[0].reMarca
        ? dato.reDatosProducto.reDatosVehiculo[0].reMarca
        : '', // Validar marca del vehículo
      placa: dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo[0] && dato.reDatosProducto.reDatosVehiculo[0].rePlaca
        ? dato.reDatosProducto.reDatosVehiculo[0].rePlaca
        : '', // Validar placa
      anio: dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo[0] && dato.reDatosProducto.reDatosVehiculo[0].reAño
        ? dato.reDatosProducto.reDatosVehiculo[0].reAño
        : '', // Validar año
      modelo: dato && dato.reDatosProducto && dato.reDatosProducto.reDatosVehiculo && dato.reDatosProducto.reDatosVehiculo[0] && dato.reDatosProducto.reDatosVehiculo[0].reModelo
        ? dato.reDatosProducto.reDatosVehiculo[0].reModelo
        : '', // Validar modelo
      estadoVer: dato && dato.reEstadoRenovacion
        ? dato.reEstadoRenovacion == 'NO_RENOVADAS' ? 'NO RENOVABLES' : dato.reEstadoRenovacion.replace('_', ' ')
        : '',
      aplicarRecompra: dato && dato.aplicarRecompra ? dato.aplicarRecompra : false, // Validar aplicar recompra
      reidPoliza: dato && dato.reidPoliza ? dato.reidPoliza : '', // Validar reidPoliza
      esRecotizacion: dato.esRecotizacion,
      sucursal: dato && dato.reDatosBroker && dato.reDatosBroker.rebrokersucursal
        ? dato.reDatosBroker.rebrokersucursal
        : '', // Validar sucursal
      prima: dato && dato.rePrimaFinal ? dato.rePrimaFinal : 0, // Validar prima
      mesCaducidad: fechaCaducidad, // Usar la fecha formateada o valor nulo si no existe,
      estadoFormVinculacion: 'Formulario Completado y Firmado',
      emailContratante: dato.reDatosContratante.reEmail,
      sumaAsegurada: sumaAsegurada,
      reIdCarrito: dato.reIdCarrito,
      procesadoCorreoCobP: dato.procesadoCorreoCobP,
      procesadoCorreoNoS: dato.procesadoCorreoNoS,
      mensajeNoRenovables: dato.mensajeNoRenovables ? dato.mensajeNoRenovables : ' No cumple con los requisitos establecidos para la renovación',
      fechaCaducidadCobP: dato.fechaCaducidadCobP,
      vehiculoAll: vehiculoAll,
      fechaCaducidadNoS: dato.fechaCaducidadNoS,
      productoExterno: dato.productoExterno,
      reProductoNuevo: dato.reDatosProducto.reProductoNuevo ? dato.reDatosProducto.reProductoNuevo : 'comparador',
      impuestos: {
        "totalcarrito": "1829.28",
        "prima_neta_anual_full_cobertura": "1,524.70",
        "prima_neta_anual_TPL": "0.00",
        "total_lost_prima_anual": "0.00",
        "super_bancos_TPL": "0.00",
        "super_bancos_Full_Cobertura": "53.36",
        "super_bancos_total_loss": "0.00",
        "seguro_campesino_TPL": "0.00",
        "seguro_campesino_Full_Cobertura": "7.62",
        "seguro_campesino_total_loss": "0.00",
        "derecho_emision_TPL": "0.00",
        "derecho_emision_Full_Cobertura": "5.00",
        "derecho_emision_total_loss": "0.00",
        "iva_TPL": "0.00",
        "iva_Full_Cobertura": "238.60",
        "iva_Total_Loss": "0.00",
        "primaTotal_TPL": "0.00",
        "primaTotal_Total_Loss": "0.00",
        "totalImpuestos": "304.58"
      },
      multiple: dato.reDatosProducto.multiple,
      siniestralidad1: dato && dato.reDatosPagador && dato.reDatosPagador.rePjeSiniestralidad,
      siniestralidad2: dato && dato.reDatosPagador && dato.reDatosPagador.rePjeSiniestralidad,

    };

    if (
      !validarBotonCarta(datoModificado) &&
      !validarBotonContinuar(datoModificado) &&
      !validarBotonRenovar(datoModificado) &&
      !validarBotonRecompra(datoModificado) &&
      !validarCoberturaProvisional(datoModificado) &&
      datoModificado.estado != 'NO_SINIESTROS_SOLICITADA' &&
      //      datoModificado.estado != 'NO_SINIESTROS_FIRMADA' &&
      datoModificado.estado != 'EN_PROCESO_2' &&
      datoModificado.estado != 'NO_RENOVABLE' &&
      datoModificado.estado != 'FVP' &&
      datoModificado.estado != 'FVC' &&
      datoModificado.estado != 'ES' &&
      datoModificado.estado != 'RENOVADA' &&
      datoModificado.estado != 'ET' &&
      datoModificado.polDescripcionSeguroVer != 'KÍLOMETROS PAQUETE' &&
      datoModificado.polDescripcionSeguroVer != 'KÍLOMETROS PAQUETE'

    ) {
      datoModificado.estado = 'VENCIDAS'
      datoModificado.estadoVer = datoModificado.aplicarRecompra ? 'Recompra vencida' : 'Renovación vencida'
    }

    console.log('datoModificado', datoModificado)


    return datoModificado;
  });
}


export const validarPolizaVencida = (datoModificado) => {

  if (
    !validarBotonCarta(datoModificado) &&
    validarBotonContinuar(datoModificado) &&
    !validarBotonRenovar(datoModificado) &&
    !validarBotonRecompra(datoModificado) &&
    !validarCoberturaProvisional(datoModificado) &&
    datoModificado.estado != 'NO_SINIESTROS_SOLICITADA' &&
    datoModificado.estado != 'NO_SINIESTROS_FIRMADA' &&
    datoModificado.estado != 'EN_PROCESO_2' &&
    datoModificado.estado != 'NO_RENOVABLE' &&
    datoModificado.polDescripcionSeguroVer != 'KÍLOMETROS PAQUETE'

  ) {
    return true
  } {

    return false
  }


}







export const cambiarContraseniaFetch = (body, history) => async (dispatch) => {
  //console.log("cambiar", urlCambiarContrasenia + body);
  dispatch(cambiarContraseniaIsLoading());
  await fetch(urlCambiarContrasenia + body)
    .then((response) => response.json())
    .then((data) => {
      //console.log(data);

      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(setContraseniaOK(true));
      } else {
        dispatch(cambiarContraseniaError());
        if (data.errorDescripcion) {
          dispatch(setMsgCambiarContrasena(data.errorDescripcion));
        }
      }
    })

    .catch(() => {
      dispatch(cambiarContraseniaError());
    });
};

export const verificarTokenFetch = (body, history) => async (dispatch) => {
  //console.log("cambiar", urlVerificarToken + body);
  dispatch(verificarTokenIsLoading());
  await fetch(urlVerificarToken + body)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);

      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(recuperarContraseniaOK(true));
      } else {
        dispatch(verificarTokenError());
      }
    })

    .catch(() => {
      dispatch(verificarTokenError());
    });
};

export const obtenerCarritoPorIdCarrito = async (idCarrito) => {
  // Construye la URL de búsqueda usando el idCarrito
   var url = `${urlListarCarrito}${idCarrito}`;
  try {
    const data = await httpClient.get(url);
    if (data && data.transaccion == true) {
      // Devuelve la info transformada del primer resultado
      return data;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const loginClienteFinalFetch = (data) => async (dispatch) => {
  console.log('loginClienteFinalFetch',data);
  let nombres1 = data.cliNombre1 + " " + data.cliNombre2;
  let apellidos1 = data.cliApellido1 + " " + data.cliApellido2;
  let disFechaAux = "";
  if (
    data.disclaimerFecha !== null &&
    data.disclaimerFecha !== "" &&
    data.disclaimerFecha !== undefined
  ) {
    disFechaAux = data.disclaimerFecha;
  }
  if (!data.cliNombre2) nombres1 = data.cliNombre1;

  if (!data.cliApellido2) apellidos1 = data.cliApellido1;

  const dataUsuario2 = {
    ...dataUsuario1,
    correo: data.cliEmail,
    cedula: data.cliIdentificacion,
    nombres: nombres1,
    apellidos: apellidos1,
    sucursal: data.cliSucursal,
    sucursalCodCore: data.sucCodigoCore,
    errorDescripcion: data.errorDescripcion,
    userIsLoggedIn: true,
    cliCodigoCore: data.carDatosAsesor.cliCodigoCore,
    disclaimerVer: data.disclaimerVer,
    disclaimerFecha: disFechaAux,
    disclaimerUrl: data.disclaimerUrl,
    usu_tipo_usuario: data.cliTipo,
    brokerRUC: data.carDatosAsesor.brokerRUC ? data.carDatosAsesor.brokerRUC : "",
    brokerNombre: data.carDatosAsesor.brokerNombre ? data.carDatosAsesor.brokerNombre : "",
    brokerCodigo: data.carDatosAsesor.brokerCodigo ? data.carDatosAsesor.brokerCodigo : "",
    fechaUltimoAcceso:moment(new Date()).format("DD-MM-YYYY HH:mm:ss"),
    fromMobile:true,
    tipoCotizador:data.tipoCotizador,
    clienteFinal:true
  };
  console.log('dataUsuario2',dataUsuario2);
  dispatch(dataUsuario(dataUsuario2));
};
export const FetchListadoCompras = (param, ambiente) => async (dispatch) => {
  var url = `${urlListarCompras}${param}&ambiente=${ambiente}`;
  //console.log("AAAAAAAAAAAAAAA", url)
  dispatch(listaComprasIsLoading());
  await fetch(url)
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        if (data.arraycompras !== undefined) {

          console.log('Compras-Ventas 2',data)
          dispatch(limpiarListaCompras());
          dispatch(setListaCompras(data.arraycompras));
          dispatch(setListaRamos(data.ramosfiltro));
        } else {
          dispatch(limpiarListaCompras());
        }
      } else {
        dispatch(listaComprasHasErrored());
      }
    })
    .catch((response) => {
      dispatch(listaComprasHasErrored());
    });
};

/*Mobile */
export const loginMobileFetch = (data) => async (dispatch) => {
  console.log('loginMobileFetch',data);
  let nombres1 = data.cliNombre1 + " " + data.cliNombre2;
  let apellidos1 = data.cliApellido1 + " " + data.cliApellido2;
  let disFechaAux = "";
  if (
    data.disclaimerFecha !== null &&
    data.disclaimerFecha !== "" &&
    data.disclaimerFecha !== undefined
  ) {
    disFechaAux = data.disclaimerFecha;
  }
  if (!data.cliNombre2) nombres1 = data.cliNombre1;

  if (!data.cliApellido2) apellidos1 = data.cliApellido1;

  const dataUsuario2 = {
    ...dataUsuario1,
    correo: data.cliEmail,
    cedula: data.cliIdentificacion,
    nombres: nombres1,
    apellidos: apellidos1,
    sucursal: data.cliSucursal,
    sucursalCodCore: data.sucCodigoCore,
    errorDescripcion: data.errorDescripcion,
    userIsLoggedIn: true,
    cliCodigoCore: data.cliCodigoCore,
    disclaimerVer: data.disclaimerVer,
    disclaimerFecha: disFechaAux,
    disclaimerUrl: data.disclaimerUrl,
    usu_tipo_usuario: data.cliTipo,
    brokerRUC: data.brokerRUC ? data.brokerRUC : "",
    brokerNombre: data.brokerNombre ? data.brokerNombre : "",
    brokerCodigo: data.brokerCodigo ? data.brokerCodigo : "",
    fechaUltimoAcceso: data.disclaimerFecha
      ? moment(new Date()).format("DD-MM-YYYY HH:mm:ss")
      : undefined,
    fromMobile:true,
    tipoCotizador:data.tipoCotizador,
    clienteFinal:false,
  };
  console.log('dataUsuario2',dataUsuario2);
  dispatch(dataUsuario(dataUsuario2));
};


// -------------------- Validar usuarios OKTA --------------------
export const validarUsuariosOkta = ({email}) => async (dispatch) => {
  // loading
  dispatch(setOktaIsLoading());
  // llamar servicio
  await fetch(urlConsultarUsrOkta +stringABase64(email))
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(setAutenticarOkta(data.autenticarOkta));
      } else {
        dispatch(setOktaHasError());
      }
    })
    // manejar excepciones
    .catch(() => {
      dispatch(setOktaHasError());
    });
};
// -------------------- Finaliza Validar usuarios OKTA --------------------



// ------------------ FINALIZAN Funciones que utilizan Actions ------------------